import React from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ width = 40, height = 40, className = '' }) => {
  return (
    <svg
      role="img"
      aria-labelledby="siska-logo-title"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <title id="siska-logo-title">Siska Logo</title>
      <g transform="translate(50, 50)">
        <circle cx="0" cy="0" r="40" fill="#333333" />
        <circle cx="0" cy="0" r="30" fill="#ffffff" />
        <circle cx="-10" cy="-10" r="10" fill="#333333" />
        <circle cx="-10" cy="-10" r="5" fill="#ffffff" />
      </g>
    </svg>
  );
};

export default Logo;
